import { NATIONAL_CONTRACT_EMPLOYEE_LEVELS_BY_EMPLOYEE_ID } from '../Queries'
import { ApolloError, useQuery } from '@apollo/client'
import { NationalContractEmployeeLevelsByEmployeeIdQuery, NationalContractEmployeeLevelsByEmployeeIdQueryVariables } from '../../../types'

export default (
  employeeId: string,
  resigned = false,
): { data: NationalContractEmployeeLevelsByEmployeeIdQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    employeeId: employeeId,
    employeeResigned: resigned,
  }

  const { data, error, loading } = useQuery<
    NationalContractEmployeeLevelsByEmployeeIdQuery,
    NationalContractEmployeeLevelsByEmployeeIdQueryVariables
  >(NATIONAL_CONTRACT_EMPLOYEE_LEVELS_BY_EMPLOYEE_ID, {
    variables: variables,
  })

  return { data, error, loading }
}
